import React, { useRef } from "react";
import styled from 'styled-components';
import { toast } from 'react-toastify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCamera } from '@fortawesome/free-solid-svg-icons';
import { readAndCompressImage } from 'browser-image-resizer';

const ContainerStyled = styled.div`
	.photos-grid {
		display: flex;
		flex-wrap: wrap;
		gap: 8px;
		margin-bottom: 10px;

		.photo-item {
			position: relative;
			border: 1px solid lightgray;
			border-radius: 5px;
			padding: 5px;
			text-align: center;

			img {
				max-width: 80px;
				max-height: 80px;
			}

			.remove {
				position: absolute;
				top: -5px;
				right: -5px;
				background: var(--bs-danger);
				color: white;
				border: none;
				border-radius: 50%;
				width: 22px;
				height: 22px;
				font-size: 14px;
				line-height: 14px;
				padding: 0;
				cursor: pointer;
			}
		}
	}

	.upload-file {
		opacity: 0;
		width: 0;
		height: 0;
	}
`;

export default function MultiPhotoUpload({ photos, onUpload, onDelete, label, disabled }) {
	let fileRef = useRef(null);

	const handleFileChange = async (e) => {
		let file = e.target.files[0];
		if (!file) return;

		// Check extension
		let allowed = "png jpg jpeg gif bmp";
		let extension = file.type.substring(file.type.indexOf('/') + 1);
		if (!extension.length || allowed.indexOf(extension) === -1) {
			toast.error("Extensión no válida. Solo se permiten ficheros: " + allowed.replaceAll(' ', ', '));
			e.target.value = null;
			return;
		}

		await readAndCompressImage(file, {
			quality: 0.9,
			maxWidth: 800,
			maxHeight: 600,
			autoRotate: true,
		}).then(resizedImage => {
			onUpload(resizedImage);
		});

		e.target.value = null;
	};

	const handleDelete = (e, photoId) => {
		e.preventDefault();
		let c = window.confirm('¿Seguro que quieres eliminar esta foto?');
		if (!c) return;
		onDelete(photoId);
	};

	return (
		<ContainerStyled>
			<label className="fw-bold mb-1">{label}</label>
			{ photos && photos.length > 0 &&
				<div className="photos-grid">
					{ photos.map((photo) => (
						<div className="photo-item" key={photo.id}>
							<img src={photo.photo_base64} alt={photo.name} />
							{ !disabled &&
								<button className="remove" onClick={(e) => handleDelete(e, photo.id)}>&times;</button>
							}
						</div>
					))}
				</div>
			}
			{ !disabled &&
				<React.Fragment>
					<button className="btn btn-primary btn-sm" onClick={() => fileRef.current.click()}>
						<FontAwesomeIcon icon={faCamera} /> Añadir foto
					</button>
					<input type="file" className="upload-file" onChange={handleFileChange} ref={fileRef} />
				</React.Fragment>
			}
		</ContainerStyled>
	);
}
